import type { RangePrice } from '../../../types/components/PriceRange'

const defaultPriceRange: RangePrice[] = [
  {
    minValue: 0,
    maxValue: 300,
    title: `Até R$300`,
  },
  {
    minValue: 300,
    maxValue: 500,
    title: 'R$300 até R$500',
  },
  {
    minValue: 500,
    maxValue: 1000,
    title: 'R$500 até R$1000',
  },
  {
    minValue: 1000,
    maxValue: 2000,
    title: 'R$1000 até R$2000',
  },
  {
    minValue: 2000,
    maxValue: 5000,
    title: 'R$2000 até R$5000',
  },
  {
    minValue: 5000,
    maxValue: 9999999,
    title: 'Acima de R$5000',
  },
]

export default defaultPriceRange
